import jsonPackage from '../../package.json';
import MainServices from '../services/MainServices';

export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = window.navigator.language ? window.navigator.language.split('-')[0] : 'es';
export const localeOptions = [
  // { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  // { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const adminRoot = '/user';
export const mainRoot = '/app';
export const adminElNacionalRoot = '/entity';
export const mainElNacionalRoot = '/el-nacional';

export const searchPath = `${adminRoot}/#`;

export const currentUser = null;
export const isMultiColorActive = true;
export const defaultColor = getDefaultColor(window.location.host);
export const defaultRadius = getDefaultRadius(jsonPackage.supplier);
export const defaultLoginPage = getDefaultLoginPage(jsonPackage.supplier);
export const clientLoginPage = getClientLoginPage(jsonPackage.supplier);
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

export const authUserKey = '_domo_crm_user';
export const authorizationsKey = '_domo_crm_authorizations';
export const navigationMenuKey = '_domo_crm_navigationMenu';
export const widgetsKey = '_domo_crm_widgets';
export const groupsKey = '_domo_crm_groups';
export const widgetsSectionsColumnsKey = '_domo_crm_sectionsColumns';
export const notificationsKey = '_domo_crm_notifications';
export const pendingNotificationsKey = '_domo_crm_pendingNotifications';
export const reportFiltersUsersIdsKey = '_domo_crm_reportFiltersUsersIds';
export const reportFiltersUsersStatusKey = '_domo_crm_reportFiltersUsersStatus';
export const changeFinalizedPlanningStatusKey = '_domo_crm_changeFinalizedPlanningStatus';
export const reportFiltersGroupsCategoriesIdsKey = '_domo_crm_reportFiltersGroupsCategoriesIds';
export const reportFiltersRangesdatesKey = '_domo_crm_reportFiltersRangesdates';
export const valuesSystemKey = '_domo_crm_valuesSystem';
export const localeKey = '_domo_crm_locale';
export const directionKey = '_domo_crm_direction';
export const themeRadiusStorageKey = '__theme_radius';
export const themeColorStorageKey = '__theme_selected_color';
export const portfolioFiltersShowPhotographKey = '_domo_crm_portfolioFiltersShowPhotograph';
export const portfolioFiltersParametersKey = '_domo_crm_portfolioFiltersParameters';
export const projectsKey = '_domo_crm_projects';
export const homeFiltersDatesKey = '_domo_crm_homeFiltersDatesKey';
export const myNegotiationsTypesFiltersFieldOrderKey = '_domo_crm_myNegotiationsTypesFiltersFieldOrderKey';
export const progressFiltersParametersKey = '_domo_crm_progressFiltersParametersKey';
export const monitorsFiltersKey = '_domo_crm_monitorsFiltersKey';

export const rowsPerPage = [5, 10, 15, 25, 50, 100, 500, 1000, 5000];
export const imgTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'];

//entity
export const authEntityKey = '_domo_crm_entity';

//images template
export const backgroundLogin = `${MainServices.URL_SERVER}upload/frontend/background-login.jpg`;
export const formLogin = `${MainServices.URL_SERVER}upload/frontend/form-login.jpg`;
export const logoClient = `${MainServices.URL_SERVER}upload/frontend/logo-client.png`;
export const formLoginElnacional = `${window.location.protocol}/assets/img/login/fondos-form.jpg`;
export const formlgLoginElnacional = `${window.location.protocol}/assets/img/login/fondos-form-lg`;

function getDefaultColor(value: string) {
  switch (value) {
    case 'bl.domo-crm.com':
      return 'light.greenmoss';
    case 'deuna.domo-crm.com':
      return 'light.purplemonster';
    case 'ms.domo-crm.com':
      return 'light.blueolympic';
    case 'redime-ventas.domo-crm.com':
      return 'light.blueyale';
    case 'redime.domo-crm.com':
      return 'light.orangecarrot';
    default:
      return 'light.bluenavy';
  }
}

function getDefaultRadius(value: string) {
  switch (value) {
    case 'BL':
      return 'flat';
    case 'DINERS':
      return 'flat';
    case 'DEUNA':
      return 'flat';
    case 'REDIME':
      return 'flat';
    default:
      return 'flat';
    // return 'radius';
  }
}

function getDefaultLoginPage(value: string) {
  switch (value) {
    case 'BL':
      return '/user/loginBL';
    case 'DINERS':
      return '/user/login';
    case 'DEUNA':
      return '/user/login';
    case 'REDIME':
      return '/user/login';

    default:
      return '/user/login';
  }
}

function getClientLoginPage(value: string) {
  let pageDefaultLogin = 'login';
  switch (value) {
    case 'BL':
      pageDefaultLogin = 'loginBL';
      break;
    default:
      break;
  }
  return pageDefaultLogin;
}
